import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';
import { INews } from '@collections/news/interfaces';
import { pageInfoFragment } from '../common/fragments/page-info.fragment';
import { newsFragment } from './fragments/news.fragment';

export interface NewsByDateResponse {
  newsByDate: INews;
}

@Injectable()
export class NewsByDateGQL extends Query<NewsByDateResponse> {
  document = gql`
    query getNewsByDate($first: Int, $after: String, $lang: String!, $dateFrom: DateTime!, $newsStatus: String!) {
      newsByDate(first: $first, after: $after, lang: $lang, dateFrom: $dateFrom, newsStatus: $newsStatus) {
        totalCount
        edges {
          cursor
          node {
            ...news
          }
        }
        pageInfo {
          ...pageInfo
        }
      }
    }
    ${newsFragment}
    ${pageInfoFragment}
  `;
}
